import React, { useState } from 'react';
import { Card, CardHeader, CardBody, Collapse } from 'reactstrap';
import { ChevronDown, ChevronUp, Paperclip } from 'react-feather';
import { H5 } from '../../AbstractElements';
import FilesComponent from '../Pages/CallForms/Component/FilesComponent';

/**
 * Tek yerden dosya collapsible yönetimi — farklı entity'ler (kaza dosyası, ara karar,
 * karar, masraf, tahsilat, kapak vs.) için aynı davranışı sağlar. Tahkim detay
 * sayfasındaki Kaza Dosyaları tab'ındaki collapsible stili ile uyumludur.
 *
 * @param {string} title Başlık metni
 * @param {string} referenceId Dosyaların bağlı olduğu entity ID
 * @param {boolean} callFormReference true iken callFormReference filtresi (çağrı formu dosyaları)
 * @param {boolean} canEdit false iken salt-okunur (upload/delete gizli)
 * @param {boolean} defaultOpen Başlangıçta açık mı
 * @param {string[]|null} typeFilter FileType başlık filtresi (mevcut pattern)
 * @param {boolean} excludeTypes typeFilter'ı hariç tutma modu
 * @param {boolean} multiple Çoklu dosya desteği (varsayılan true)
 */
const FilesCollapsible = ({
    title,
    referenceId,
    callFormReference = false,
    canEdit = true,
    defaultOpen = false,
    typeFilter = null,
    excludeTypes = false,
    multiple = true
}) => {
    const [isOpen, setIsOpen] = useState(Boolean(defaultOpen));

    const toggle = () => setIsOpen(prev => !prev);

    return (
        <Card className="mb-3">
            <CardHeader
                className="cursor-pointer d-flex justify-content-between align-items-center p-3"
                onClick={toggle}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        toggle();
                    }
                }}
                role="button"
                tabIndex={0}
                style={{ backgroundColor: isOpen ? '#f8f9fa' : '#ffffff', cursor: 'pointer', userSelect: 'none' }}
            >
                <div className="d-flex align-items-center gap-3">
                    <Paperclip size={18} />
                    <H5 className="mb-0">{title}</H5>
                </div>
                {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
            </CardHeader>
            <Collapse isOpen={isOpen}>
                <CardBody>
                    {referenceId ? (
                        <FilesComponent
                            referenceId={referenceId}
                            callFormReference={callFormReference}
                            canEdit={canEdit}
                            multiple={multiple}
                            typeFilter={typeFilter}
                            excludeTypes={excludeTypes}
                            title=""
                            onFilesChange={() => { }}
                        />
                    ) : (
                        <div className="text-muted small">Bu öğenin referans kimliği bulunamadı.</div>
                    )}
                </CardBody>
            </Collapse>
        </Card>
    );
};

export default FilesCollapsible;
